export default "__VITE_ASSET__015b618e__"